export default __webpack_public_path__ + "static/media/workOrder.32dcdbd3.svg";